module.exports = __webpack_public_path__ + "img/skcac.e7f2d7b5.png";